var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "border-b pb-5 mb-3 flex items-center justify-between" },
    [
      _c("div", { staticClass: "flex items-center flex-1 min-w-0" }, [
        _c(
          "h2",
          {
            staticClass:
              "xl:text-2xl lg:text-xl text-lg font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate pr-2",
          },
          [_vm._v(_vm._s(_vm.heading))]
        ),
        typeof _vm.total === "number"
          ? _c(
              "div",
              {
                staticClass:
                  "border-l border-gray-300 pl-2 xl:text-2xl lg:text-xl text-lg font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate",
              },
              [
                _vm._v(" " + _vm._s(_vm.total) + " "),
                _c(
                  "span",
                  {
                    staticClass: "xl:text-xl lg:text-lg text-base font-normal",
                  },
                  [_vm._v("in total")]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "mt-5 flex justify-end lg:mt-0 lg:ml-4" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }